<template>
    <a v-bind:href="`/Template/${templateId}/Preview/Browser`" target="_blank" class="btn btn-primary">
        {{ resource('Template_BrowserPreviewButton_DisplayText') }}
    </a>
</template>

<script>
    import resourceMixin from '../../../Util/Mixins/resources'
    
    export default {
        name: "template-browser-preview-button",
        mixins: [resourceMixin],
        props: {
            templateId: {
                type: String,
                required: true
            }
        }
    };
</script>
